import React from "react";
import { Typography } from "antd";
import { useSelector } from "react-redux";
import moment from "moment";
import commaNumber from "comma-number";
import InstitutionProfile from "../../../../components/common/InstitutionProfile";
import "../../../../components/common/bt.css";

const { Title, Text } = Typography;
const format = commaNumber.bindWith(",", ".");

const ExpenseBalancePrintView = React.forwardRef((props, ref) => {
  const { list, balanceTotal } = useSelector((state) => state.expenseBalance);

  const totals = list.reduce(
    (acc, row) => {
      acc.opening_balance += Number(row.opening_balance || 0);
      acc.debit_amount += Number(row.debit_amount || 0);
      acc.credit_amount += Number(row.credit_amount || 0);
      return acc;
    },
    { opening_balance: 0, debit_amount: 0, credit_amount: 0 }
  );

  return (
    <div ref={ref} style={{ padding: 20 }}>
      <InstitutionProfile />

      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <Title level={3}>Expense Balance Report</Title>
      </div>

      <div style={{ marginBottom: 20, textAlign: "right" }}>
        <Text strong>Statement Date: {moment().format("YYYY-MM-DD")}</Text>
      </div>

      <table className="ledger-print-table">
        <colgroup>
          <col style={{ width: "5%" }} />
          <col style={{ width: "35%" }} />
          <col style={{ width: "15%" }} />
          <col style={{ width: "15%" }} />
          <col style={{ width: "15%" }} />
          <col style={{ width: "15%" }} />
        </colgroup>
        <tbody>
          <tr className="ledger-print-heading">
            <td>No.</td>
            <td>Account Name</td>
            <td style={{ textAlign: "right" }}>Opening Balance</td>
            <td style={{ textAlign: "right" }}>Debit Amount</td>
            <td style={{ textAlign: "right" }}>Credit Amount</td>
            <td style={{ textAlign: "right" }}>Expense Amount</td>
          </tr>

          {list.map((row, index) => (
            <tr key={row.id || index}>
              <td>{index + 1}</td>
              <td>{row.acc_name}</td>
              <td style={{ textAlign: "right" }}>
                {format(parseFloat(row.opening_balance || 0).toFixed(2))}
              </td>
              <td style={{ textAlign: "right" }}>
                {format(parseFloat(row.debit_amount || 0).toFixed(2))}
              </td>
              <td style={{ textAlign: "right" }}>
                {format(parseFloat(row.credit_amount || 0).toFixed(2))}
              </td>
              <td style={{ textAlign: "right" }}>
                {format(parseFloat(row.balance || 0).toFixed(2))}
              </td>
            </tr>
          ))}

          <tr className="ledger-total-row">
            <td colSpan={2} style={{ textAlign: "right" }}>
              Grand Total
            </td>
            <td style={{ textAlign: "right" }}>
              {format(totals.opening_balance.toFixed(2))}
            </td>
            <td style={{ textAlign: "right" }}>
              {format(totals.debit_amount.toFixed(2))}
            </td>
            <td style={{ textAlign: "right" }}>
              {format(totals.credit_amount.toFixed(2))}
            </td>
            <td style={{ textAlign: "right" }}>
              {format(parseFloat(balanceTotal || 0).toFixed(2))}
            </td>
          </tr>
        </tbody>
      </table>

      <div style={{ marginTop: 50 }}>
        <div style={{ float: "left", width: 150, borderTop: "1px solid #000", textAlign: "center" }}>
          Received By
        </div>

        <div style={{ float: "right", width: 150, borderTop: "1px solid #000", textAlign: "center" }}>
          Authorized By
        </div>

        <div style={{ clear: "both" }}></div>
      </div>
    </div>
  );
});

export default ExpenseBalancePrintView;
